// hamburger nav
const header = document.querySelector('header');

const breakpoint = 1290;
if (window.innerWidth < breakpoint && header) {
  window.addEventListener('load', (event) => {
    const button = document.querySelector('.menu-button');
    const navBar = document.querySelector('header ul');
    const parent = document.querySelectorAll('.menu-item-has-children >a');
    const arrow = document.querySelectorAll('.menu-item-has-children >button');

    button.onclick = function toggleMenu() {
      if (navBar.matches('.show')) {
        navBar.classList.remove('anim');
        setTimeout(function () {
          navBar.classList.remove('show');
        }, 300);
        button.classList.remove('menu-close');
        header.classList.remove('show');
      } else {
        navBar.classList.add('show');
        setTimeout(function () {
          navBar.classList.add('anim');
        }, 300);
        button.classList.add('menu-close');
        header.classList.add('show');

        // Hides dropdown when menu is hidden
        parent.forEach(function (ele) {
          ele.classList.remove('show-ul');
        });
      }
    };
  });
}
